export default __webpack_public_path__ + "static/launch-partner_divinedao_right@2x-e6415ce4e39925c99d9955907b9457d8.jpg";